// --- START OF FILE Footer.jsx ---

import React, { useState } from "react";
import "./Footer.css";
import logo from "../../Assets/logo.png";
import paymentIcon from "../../Assets/paymentIcon.png";

// --- THE DEFINITIVE FIX ---
// 1. All standard icons are imported from 'react-icons/fa' in one clean line.
import { FaFacebookF, FaInstagram, FaYoutube, FaPinterest } from "react-icons/fa";
// 2. The newer X icon is correctly imported from its own package 'react-icons/fa6'.
import { FaXTwitter } from "react-icons/fa6";
// --- END OF FIX ---

import { Link } from "react-router-dom";

// Import Firestore functions and our new database config
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { newsletterDb } from "../../firebase/newsletterConfig";

const Footer = () => {
  // State for the email input and for any messages
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // A helper function to validate email format
  const validateEmail = (email) => {
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");

    if (!email || !validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      await addDoc(collection(newsletterDb, "subscribers"), {
        email: email,
        timestamp: serverTimestamp(),
      });
      setSuccessMessage("Thank you for subscribing!");
      setEmail("");
    } catch (err) {
       console.error("Error adding document: ", err);
      setError("Subscription failed. Please try again later.");
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="footer">
        <div className="footer__container">
          {/* LEFT & MIDDLE SECTIONS */}
          <div className="footer_left">
            <div className="footer_logo_container">
              <img src={logo} alt="Zircon Jewels Logo" />
            </div>
            <p>Hussain Center, Zabunnisa street, Saddar, Karachi, Pakistan</p>
            <div className="footer_address">
              <strong> zircongemsandjewels@gmail.com </strong>
              <strong> +92 328 2243950 </strong>
            </div>
            <div className="footer_content">
              <h5>Wholesale</h5>
              <ul onClick={scrollToTop}>
                <p>We provide nationwide bulk delivery services to Islamabad, Lahore, and other major cities.</p>
                <p>Interested customers can contact us via phone </p>
              </ul>
            </div>  
            <br />
            {/* Using the correctly imported icons */}
            <div className="social_links">
              <FaFacebookF />
              <FaXTwitter />
              <FaInstagram />
              <FaYoutube />
              <FaPinterest />
            </div>
          </div>
          <div className="footer_content">
            <h5>Company</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/about">Career</Link></li>
                <li><Link to="*">Affilates</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer_content">
            <h5>Shop</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li><Link to="/shop">New Arrivals</Link></li>
                <li><Link to="/shop">Accessories</Link></li>
                <li><Link to="/shop">Men</Link></li>
                <li><Link to="/shop">Women</Link></li>
                <li><Link to="/shop">Shop All</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer_content">
            <h5>Help</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li><Link to="/contact">Customer Service</Link></li>
                <li><Link to="/loginSignUp">My Account</Link></li>
                <li><Link to="/contact">Find a Store</Link></li>
                <li><Link to="/terms">Legal & Privacy</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/">Gift Card</Link></li>
              </ul>
            </div>
          </div>

          {/* RIGHT SECTION */}
          <div className="footer_right">
            <h5>Subscribe</h5>
            <p>
              Be the first to get the latest news about trends, promotions, and
              much more!
            </p>
            <form onSubmit={handleSubscribe}>
              <input 
                type="email" 
                placeholder="Your email address" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit">Join</button>
            </form>
            {error && <p className="error-message">{error}</p>}
            {successMessage && <p className="success-message">{successMessage}</p>}
            <h6>Secure Payments</h6>
            <div className="paymentIconContainer">
              <img src={paymentIcon} alt="Secure Payment Icons" />
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <p>
            © Zircon Jewels. All Rights Reserved | Crafted by{" "}
            <a href="https://www.instagram.com/zircon___jewels/" target="_blank" rel="noreferrer" style={{ color: "#C22928", textDecoration: "none" }}>
              Zircon Jewels
            </a>{" "} with ❤️
          </p>
          <div className="footerLangCurrency">
            <div className="footerLang">
              <p>Language</p>
              <select name="language" id="language">
                <option value="english">United States | English</option>
                <option value="Hindi">Hindi</option>
                <option value="Germany">Germany</option>
                <option value="French">French</option>
              </select>
            </div>
            <div className="footerCurrency">
              <p>Currency</p>
              <select name="currency" id="currency">
                <option value="USD">Rs PKR</option>
              </select>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;